import React, { createContext, useState } from "react";
import * as authService from "./authService";

export const AuthContext = createContext();

export function AuthProvider({ children }) {

  const [token, setToken] = useState(authService.getToken());
  const [user, setUser] = useState(authService.getUser());

  const login = (authData) => {
    authService.saveAuth(authData);
    setToken(authData.token);
    setUser(authData.user);
  };

  const logout = () => {
    authService.logout();
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
